var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 118,
    viewBox: "0 0 121 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5625,
    y: 1,
    width: 115.063,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5625,
    y: 2,
    width: 115.063,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8071 23.1734V74.519C57.6519 86.2914 45.7137 83.8571 41.8973 80.7773C40.4616 79.6187 39.1502 76.951 38.7155 74.519C38.2576 71.9573 38.7155 69.6571 38.7155 69.6571C40.3621 61.3355 50.6741 61.3355 50.6741 61.3355V51.6215C25.951 52.3153 27.601 74.519 27.601 74.519C27.601 74.519 27.601 84.2629 34.6024 89.5371C34.6024 89.5371 41.3258 94 48.5989 94C58.2121 94 64.2385 89.5371 64.2385 89.5371C64.6799 88.7257 70.0018 85.48 72.0562 76.0763M61.9844 23H72.5875M72.0562 44.1626V75.9067M90.612 52.3153V40.1728C73.2989 33.5486 73.0071 25.8868 72.7191 23.7281M72.3646 44.5306C74.9235 47.7474 78.8197 49.6093 82.66 51.0024C85.0028 51.8523 87.5316 52.3892 90.0251 52.3892",
    stroke: "#11141D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8071 24.1734V75.519C60.6519 87.2914 48.7137 84.8571 44.8973 81.7773C43.4616 80.6187 42.1502 77.951 41.7155 75.519C41.2576 72.9573 41.7155 70.6571 41.7155 70.6571C43.3621 62.3355 53.6741 62.3355 53.6741 62.3355V52.6215C28.951 53.3153 30.601 75.519 30.601 75.519C30.601 75.519 30.601 85.2629 37.6024 90.5371C37.6024 90.5371 44.3258 95 51.5989 95C61.2121 95 67.2385 90.5371 67.2385 90.5371C67.6799 89.7257 73.0018 86.48 75.0562 77.0763M64.9844 24H75.5875M75.0562 45.1626V76.9067M93.612 53.3153V41.1728C76.2989 34.5486 76.0071 26.8868 75.7191 24.7281M75.3646 45.5306C77.9235 48.7474 81.8197 50.6093 85.66 52.0024C88.0028 52.8523 90.5316 53.3892 93.0251 53.3892",
    stroke: "#11141D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTik);
export default __webpack_public_path__ + "static/media/tik.3658c1caed462e281e5963ec9a74db06.svg";
export { ForwardRef as ReactComponent };